import React, { useContext, useState } from "react";
import { IconChevronDown } from "@tabler/icons-react";
import { COLORS } from "@app/constants/";
import CButton from "../../CButton";
import { CDropDownSection, DropdownContainer } from "./styles";
import { ThemeContext } from "@/theme/ThemeProvider";

const CDropDown = ({ title, icon, style, renderDropDown, btnStyle }: any) => {
  const [show, setShow] = useState(false);
  const { textw } = useContext(ThemeContext).theme.COLORS;
  return (
    <CDropDownSection>
      <CButton
        icon={
          icon ? (
            icon
          ) : (
            <IconChevronDown
              size={12}
              style={{ marginLeft: 3 }}
              color={textw}
            />
          )
        }
        title={title ? title : ""}
        onClick={() => {
          setShow(!show);
        }}
        textHover={COLORS.primary}
        style={{
          color: COLORS.grayWhite,
          paddingInline: 10,
          fontSize: 12,
          ...btnStyle,
        }}
      />
      {show ? (
        <DropdownContainer
          style={{
            display: "flex",
            flexDirection: "column",
            ...style,
          }}
        >
          {renderDropDown(show, setShow)}
        </DropdownContainer>
      ) : null}
    </CDropDownSection>
  );
};

export default React.memo(CDropDown);
